/* this file added by Bearer Web Developer  */
import React, { useState } from 'react';
import styles from './switchPlace.module.scss';
import { useAppState } from '../../../states/app-state';
import { observer } from 'mobx-react-lite';
import OriginHandler from '../../origin/OriginHandler';
import DestinationHandler from '../../destination/DestinationHandler';
import SwitchConfirmPopup from './switchConfirmPopup';
import ToastMui from './toastMui';

const SwitchPlace: React.FC = observer(() => {

    const appState = useAppState();
    const [openSwitchConfirmPopup, setOpenSwitchConfirmPopup] = useState(false);
    const [openToast, setOpenToast] = useState<boolean>(false);
    const handleOpenToast = () => {
        setOpenToast(true);
    };
    const handleCloseToast = () => {
        setOpenToast(false);
    };
    const handleOpenSwitchConfirmPopup = () => {
        setOpenSwitchConfirmPopup(true);
    }
    const handleCloseSwitchConfirmPopup = () => {
        setOpenSwitchConfirmPopup(false);
    }
    const origin = appState.selectedOrder?.origin;
    const parcelType = appState.selectedOrder?.parcelType;
    const order = appState.selectedOrder;
    const destination = appState.selectedOrder?.destination;
    const showSwitch = origin?.address && destination?.address && !origin?.editing && !destination?.editing &&
        parcelType?.editing;

    if (!order) return (<></>);
    return (
        <div className={`${styles.switch_place} ${showSwitch ? styles.show_switch : ''}`}>
            <OriginHandler origin={order?.origin} destination={order?.destination} />
            <ToastMui handleClose={handleCloseToast} open={openToast} />
            {
                showSwitch &&
                <>
                    <div className={styles.switch_part}>
                        <div className={styles.switch}>
                            <img src="/swap-place.svg" alt="" width={44} height={44} onClick={handleOpenSwitchConfirmPopup} />
                        </div>
                    </div>
                    <SwitchConfirmPopup open={openSwitchConfirmPopup} handleOpenToast={handleOpenToast} handleClose={handleCloseSwitchConfirmPopup} />
                </>
            }
            <DestinationHandler destination={order.destination} parcel={order.parcelType} />
        </div>
    );
})
export default SwitchPlace;